/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{RgbaFloatEncoding as e}from"../../../core/shaderLibrary/util/RgbaFloatEncoding.glsl.js";import{FloatDrawUniform as t}from"../../../core/shaderModules/FloatDrawUniform.js";import{NoParameters as r,glsl as a}from"../../../core/shaderModules/interfaces.js";import{Texture2DDrawUniform as s}from"../../../core/shaderModules/Texture2DDrawUniform.js";import{usesSketchLogic as o,EdgeUtilMode as u}from"./EdgeUtil.glsl.js";import{UnpackAttributes as l}from"./UnpackAttributes.glsl.js";class c extends r{}function n(r,c){r.include(l,c);const{vertex:n,fragment:i}=r;switch(o(c)&&(n.uniforms.add(new s("strokesTexture",(e=>e.strokesTexture.texture))),n.uniforms.add(new t("strokesLog2Resolution",(e=>Math.log2(e.strokesTexture.resolution))),new t("strokeVariants",(e=>e.strokesTexture.variants))),r.varyings.add("vStrokeUV","vec2"),i.uniforms.add(new s("strokesTexture",(e=>e.strokesTexture.texture)),new t("strokesNormalizationScale",(e=>e.strokesTexture.normalizationScale))),n.code.add(a`void calculateStyleOutputsSketch(float lineLength, UnpackedAttributes unpackedAttributes) {
vec2 sidenessNorm = unpackedAttributes.sidenessNorm;
float lineIndex = clamp(ceil(log2(lineLength)), 0.0, strokesLog2Resolution);
vStrokeUV = vec2(exp2(lineIndex) * sidenessNorm.y, lineIndex * strokeVariants + variantStroke + 0.5) / vec2(textureSize(strokesTexture, 0));
vStrokeUV.x += variantOffset;
}`),r.fragment.include(e),i.code.add(a`float calculateLineOffsetSketch() {
float offsetNorm = rgba2float(texture(strokesTexture, vStrokeUV));
return (offsetNorm - 0.5) * strokesNormalizationScale;
}
float calculateLinePressureSketch() {
return rgba2float(texture(strokesTexture, vStrokeUV + vec2(0.0, 0.5)));
}`)),c.mode){case u.SOLID:n.code.add(a`void calculateStyleOutputs(UnpackedAttributes unpackedAttributes) {}`),i.code.add(a`float calculateLineOffset() {
return 0.0;
}
float calculateLinePressure() {
return 1.0;
}`);break;case u.SKETCH:n.code.add(a`void calculateStyleOutputs(UnpackedAttributes unpackedAttributes)
{
calculateStyleOutputsSketch(vLineLengthPixels, unpackedAttributes);
}`),i.code.add(a`float calculateLineOffset() {
return calculateLineOffsetSketch();
}
float calculateLinePressure() {
return calculateLinePressureSketch();
}`);break;case u.MIXED:r.varyings.add("vType","float"),n.code.add(a`void calculateStyleOutputs(UnpackedAttributes unpackedAttributes)
{
vType = unpackedAttributes.type;
if (unpackedAttributes.type <= 0.0) {
calculateStyleOutputsSketch(vLineLengthPixels, unpackedAttributes);
}
}`),i.code.add(a`float calculateLineOffset() {
if (vType <= 0.0) {
return calculateLineOffsetSketch();
}
else {
return 0.0;
}
}
float calculateLinePressure() {
if (vType <= 0.0) {
return calculateLinePressureSketch();
}
else {
return 1.0;
}
}`)}}export{n as LineOffset,c as LineOffsetDrawParameters};
